import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { HomeBannersModule } from '@shared/home-banners/home-banners.module';
import { DirectivesModule } from '@directives/directives.module';
import { ShopBannersComponent } from './shop-order-banners.component';

@NgModule({
  imports: [CommonModule, CsIconModule, HomeBannersModule, DirectivesModule],
  declarations: [ShopBannersComponent],
  exports: [ShopBannersComponent],
})
export class ShopBannersModule {}
